import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Package = ({ packages, cardsPerRow = 4 }) => {
  const rows = [];
  for (let i = 0; i < packages.length; i += cardsPerRow) {
    rows.push(packages.slice(i, i + cardsPerRow));
  }

  return (
    <div className="bg-light py-5">
      <Container>
        <h2 className="fw-bold my-2 text-center">Package Options</h2>
        <div
          className="mx-auto mb-5"
          style={{
            width: '60px',
            height: '4px',
            backgroundColor: '#3bc9f5',
            borderRadius: '2px',
          }}
        ></div>

        {rows.map((row, rowIndex) => (
          <Row key={rowIndex} className="mb-4 justify-content-center">
            {row.map((pkg, index) => (
              <Col key={index} md={12 / cardsPerRow} className="mb-4">
                <div className="card h-100 shadow border-0">
                  <div
                    className="card-header text-white text-center fw-bold"
                    style={{
                      backgroundColor: '#6bdcf5',
                      transform: 'skewY(-4deg)',
                      marginBottom: '1rem',
                    }}
                  >
                    <div style={{ transform: 'skewY(4deg)', fontSize: '2rem' }}>
                      {pkg.title}
                    </div>
                  </div>
                  <div className="card-body text-center d-flex flex-column justify-content-between">
                    <ul className="list-unstyled flex-grow-1">
                      {pkg.features.map((feature, i) => (
                        <li
                          key={i}
                          className={`mb-2 ${
                            feature.isDisabled ? 'text-muted' : 'text-dark'
                          }`}
                          style={{ opacity: feature.isDisabled ? 0.4 : 1 }}
                        >
                          {feature.label}
                        </li>
                      ))}
                    </ul>
                   <a href='#GetInTouchForm'><button className="btn btn-info text-white fw-bold w-100">
                      {pkg.buttonText}
                    </button></a> 
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        ))}
      </Container>
    </div>
  );
};

export default Package;
